<template>
  <div
    class="drag-container"
    :class="{
      active: hasClass && dragEnter,
      'pointer-events-children': hasClass && isPointEvents
    }"
    @dragenter.prevent.stop="onDragEnter"
    @dragover.prevent.stop="onDragOver"
    @dragleave.prevent.stop="onDragLeave"
    @drop.prevent.stop="onDrop"
  >
    <slot></slot>
    <!-- <uploadModal
      v-model="uploadVisible"
      :files="fileList"
      :isDir="isDir"
      :project="project"
    ></uploadModal> -->
  </div>
</template>

<script>
// import uploadModal from '@/components/upload/index'
export default {
  name: '',
  // components: {
  //   uploadModal
  // },
  props: {
    project: {
      type: Boolean,
      default () {
        return false
      }
    },
    // size: {
    //   type: Number,
    //   default: 0
    // },
    hasClass: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      dragEnter: false,
      fileList: [],
      // uploadVisible: false,
      isDir: false,
      isDrag: false,
      isPointEvents: false
    }
  },
  // watch: {
  //   fileList (val) {
  //     console.log('fileList', val)
  //   }
  // },
  methods: {
    onDragEnter (e) {
      // console.log('enter')
      this.dragEnter = true
      this.isPointEvents = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.isDrag = true
        })
      })
    },
    onDragLeave (e) {
      // console.log(this.isDrag)
      if (!this.isDrag) {
        return
      }
      // console.log('leave')
      this.dragEnter = false
      this.isDrag = false
      this.isPointEvents = false
    },
    onDragOver (e) {
      // console.log('over')
      if (this.req) {
        window.cancelAnimationFrame(this.req)
      }
      this.req = window.requestAnimationFrame(() => {
        // this.dragEnter = true;
      })
    },
    async onDrop (e) {
      // this.$emit('onDrop')
      // console.log('drop')
      window.cancelAnimationFrame(this.req)
      this.dragEnter = false
      this.isDrag = false
      this.isPointEvents = false
      this.fileList = []
      for (let i = 0; i < e.dataTransfer.items.length; i++) {
        const item = e.dataTransfer.items[i]
        const entry = item.webkitGetAsEntry()
        if (entry) {
          if (entry.isDirectory) {
            this.isDir = true
            await this.traverseFileTree(entry, entry.name)
          } else {
            this.addFile(item.getAsFile())
          }
        }
      }
      this.uploadFiles()
    },
    addFile (file) {
      if (file) {
        this.fileList.push(file)
      }
    },
    async traverseFileTree (dir, path) {
      let item = await this.getEntryItem(dir, path)
      const dirList = [item]
      while (dirList.length) {
        const { entries, path } = dirList.shift()
        for (let i = 0; i < entries.length; i++) {
          const entry = entries[i]
          if (entry.isFile) {
            const file = await this.getFileForFileEntry(entry, path)
            this.addFile(file)
          } else {
            item = await this.getEntryItem(entry, `${path}/${entry.name}`)
            dirList.push(item)
          }
        }
      }
    },
    getEntryItem (directory, path) {
      return new Promise((resolve, reject) => {
        const dirReader = directory.createReader()
        dirReader.readEntries(
          entries => {
            resolve({ entries, path })
          },
          error => {
            return typeof console !== 'undefined' && console !== null
              ? typeof console.log === 'function'
                ? console.log(error)
                // eslint-disable-next-line no-void
                : void 0
              // eslint-disable-next-line no-void
              : void 0
          }
        )
      })
    },
    getFileForFileEntry (fileEntry, path) {
      return new Promise((resolve, reject) => {
        fileEntry.file(
          file => {
            if (file.name.substring(0, 1) === '.') {
              resolve(null)
            } else {
              file.fullPath = '' + path + '/' + file.name
              resolve(file)
            }
          },
          error => {
            reject(new Error(' getFileForFileEntry 文件解析错误'))
            console.error(error)
          }
        )
      })
    },
    uploadFiles () {
      this.$emit('add', this.fileList)
      // const addSize = this.fileList.reduce((total, item) => (total + item.size), 0)
      // if (this.size + addSize > 1024 * 1024 * 1024 * 5) {
      //   this.$Message.warning({
      //     content: '上传的全部素材不能超过5G',
      //     background: true
      //   })
      // } else {
      //   this.$emit('add', this.fileList)
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.drag-container {
  height: 100%;
  // border: 1px dashed #D5D7DD;
  border-radius: 4px;
  &.pointer-events-children * {
    pointer-events: none;
  }
  &.active {
    position: relative;
    border-radius: 4px;
    // border: 1px solid #3D7AF5;
    &::after {
      content: '拖拽至此处并松开鼠标';
      display: flex;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      color: #323337;
      background-color: #eaf0ff;
      border-radius: 4px;
      z-index: 1100;
    }
  }
}
</style>
